import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';

const SidebarMokaLogo = props => {
  const { mokapayMode, link } = props;
  let imgProps;

  if (mokapayMode) {
    imgProps = {
      src: require('assets/images/logo-mokapay-full.svg'),
      width: 151,
      height: 25,
    };
  } else {
    imgProps = {
      src: require('assets/images/logo-moka-full.png'),
      width: 103,
      height: 22,
    };
  }

  return (
    <li className="sidebar-brand">
      <Link to={link} className="logo-moka-full">
        <img {...imgProps} />
      </Link>
    </li>
  );
};

SidebarMokaLogo.propTypes = {
  mokapayMode: PropTypes.bool,
  link: PropTypes.string,
};

SidebarMokaLogo.defaultProps = {
  mokapayMode: false,
  link: '',
};

export default SidebarMokaLogo;
